module.exports = __webpack_public_path__ + "static/media/back.071e2ff1.svg";